// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"70a55bc3","806":"bca1f093"}[chunkId] + ".chunk.js";
};